import http from '../../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/inventoryReport/bscHhptInventoryReport',
    // 分页查询月报
    selectReportPage(f) {
        return http({
            url: this.baseurl + '/selectReportPage',
            method: 'post',
            params: f
        });
    },
    // 获取可用年月列表
    getYearMonths() {
        return http({
            url: this.baseurl + '/getYearMonths',
            method: 'post'
        });
    },
    // 手动生成指定月份报表
    generateReport(yearMonth) {
        return http({
            url: this.baseurl + '/generateReport?yearMonth=' + yearMonth,
            method: 'post'
        });
    },
    // 导出Excel
    downloadExcel(f) {
        return http({
            url: this.baseurl + '/downloadExcel',
            method: 'get',
            params: f,
            responseType: 'blob'
        });
    },
}
